<template>
<div class="wenhui-services-page">
    <!-- 科技感服务Banner -->
    <div class="tech-services-banner">
        <div class="banner-content">
            <h1>科技服务</h1>
            <p>赋能数字化转型 · 引领技术未来</p>
            <div class="tech-grid">
                <div class="grid-cell" v-for="i in 36" :key="i" @mouseover="activateCell(i)"></div>
            </div>
        </div>
    </div>

    <!-- 服务分类导航 - 科技风格 -->
    <div class="section tech-categories">
        <div class="container">
            <el-tabs v-model="activeCategory" @tab-click="handleTabChange" class="tech-tabs">
                <el-tab-pane v-for="category in categories" :key="category.id" :label="category.name" :name="category.id">
                    <div class="tech-category-description">
                        <p>{{ category.description }}</p>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>

    <!-- 服务列表 - 科技卡片 -->
    <div class="section tech-service-list">
        <div class="container">
            <el-row :gutter="30">
                <el-col v-for="service in filteredServices" :key="service.id" :xs="24" :sm="12" :md="8" :lg="8">
                    <div class="tech-service-card" @click="showServiceDetail(service)">
                        <div class="tech-service-image">
                            <img :src="service.image" :alt="service.name">
                            <div class="tech-service-tags">
                                <span v-for="(tag, i) in service.tags" :key="i">{{ tag }}</span>
                            </div>
                        </div>
                        <div class="tech-service-content">
                            <h3>{{ service.name }}</h3>
                            <div class="tech-service-meta">
                                <span class="duration"><i class="el-icon-time"></i> {{ service.duration }}</span>
                                <span class="price">¥{{ service.price }}</span>
                            </div>
                            <p class="tech-service-desc">{{ service.shortDesc }}</p>
                            <div class="tech-service-footer">
                                <el-button type="primary" size="mini" round @click.stop="handleConsult(service)">
                                    立即咨询
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>

    <!-- 服务详情弹窗 - 科技风格 -->
    <el-dialog :title="currentService.name" :visible.sync="detailVisible" width="70%" class="tech-service-dialog">
        <div class="tech-service-detail">
            <el-row :gutter="40">
                <el-col :span="12">
                    <div class="tech-detail-image">
                        <img :src="currentService.image" :alt="currentService.name">
                        <div class="tech-stack">
                            <div class="tech-stack-item" v-for="(tech, index) in currentService.techStack" :key="index">
                                <img :src="tech.logo" :alt="tech.name">
                                <span>{{ tech.name }}</span>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="tech-detail-content">
                        <div class="tech-detail-header">
                            <h3>{{ currentService.name }}</h3>
                            <div class="tech-price">
                                <span class="amount">¥{{ currentService.price }}</span>
                                <span class="duration">/{{ currentService.duration }}</span>
                            </div>
                        </div>
                        <el-divider class="tech-divider"></el-divider>
                        <div class="tech-detail-section">
                            <h4><i class="el-icon-document"></i> 服务描述</h4>
                            <p>{{ currentService.description }}</p>
                        </div>
                        <el-divider class="tech-divider"></el-divider>
                        <div class="tech-detail-section">
                            <h4><i class="el-icon-star-off"></i> 核心优势</h4>
                            <ul class="tech-benefits">
                                <li v-for="(benefit, index) in currentService.benefits" :key="index">
                                    <i class="el-icon-success"></i> {{ benefit }}
                                </li>
                            </ul>
                        </div>
                        <el-divider class="tech-divider"></el-divider>
                        <div class="tech-detail-section">
                            <h4><i class="el-icon-s-operation"></i> 技术架构</h4>
                            <div class="tech-architecture">
                                <img :src="currentService.architecture" alt="技术架构图" v-if="currentService.architecture">
                                <p v-else>{{ currentService.techDesc }}</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <span slot="footer" class="tech-dialog-footer">
            <el-button class="tech-cancel-btn" @click="detailVisible = false">
                关闭
            </el-button>
            <el-button class="tech-consult-btn" type="primary" @click="handleConsult(currentService)">
                立即咨询
            </el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    name: 'WenhuiServicesPage',
    data() {
        return {
            activeCategory: 'training',
            detailVisible: false,
            currentService: {
                id: '',
                name: '',
                description: '',
                price: '',
                duration: '',
                image: '',
                benefits: [],
                techStack: [],
                architecture: ''
            },
            categories: [
                {
                    id: 'training',
                    name: '技术培训',
                    description: '系统化实战课程，培养符合企业需求的高端技术人才'
                },
                {
                    id: 'development',
                    name: '软件开发',
                    description: '专业团队为企业提供定制化软件开发服务'
                },
                {
                    id: 'solution',
                    name: '解决方案',
                    description: '行业领先的技术解决方案，助力企业数字化转型'
                },
                {
                    id: 'consulting',
                    name: '技术咨询',
                    description: '资深专家团队提供专业技术咨询服务'
                }
            ],
            services: [
                // 技术培训
                {
                    id: 1,
                    name: 'Java全栈工程师培训',
                    category: 'training',
                    description: '从Java基础到企业级开发，涵盖Spring全家桶、微服务架构、分布式系统等前沿技术，培养全栈开发能力。课程包含大量实战项目，学员毕业后可胜任Java全栈开发岗位。',
                    shortDesc: '从零基础到高薪就业，系统掌握Java全栈开发技能',
                    price: 8800,
                    duration: '4个月',
                    image: require('@/assets/images/base.png'),
                    tags: ['Java', 'Spring', '微服务'],
                    techStack: [
                        {name: 'Java', logo: require('@/assets/images/base.png')},
                        {name: 'Spring', logo: require('@/assets/images/base.png')},
                        {name: 'MySQL', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '10年经验讲师团队',
                        '真实企业项目实战',
                        '就业推荐服务',
                        '终身技术指导'
                    ],
                    architecture: require('@/assets/images/base.png')
                },
                {
                    id: 2,
                    name: 'PHP高级开发培训',
                    category: 'training',
                    description: '系统学习PHP开发技术，掌握Laravel、ThinkPHP等主流框架，了解高并发、高性能系统设计。课程包含电商系统、内容管理系统等实战项目。',
                    shortDesc: '快速掌握PHP企业级开发技能，胜任高级开发岗位',
                    price: 6800,
                    duration: '3个月',
                    image: require('@/assets/images/base.png'),
                    tags: ['PHP', 'Laravel', 'MySQL'],
                    techStack: [
                        {name: 'PHP', logo: require('@/assets/images/base.png')},
                        {name: 'Laravel', logo: require('@/assets/images/base.png')},
                        {name: 'Vue', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '小班制教学',
                        '项目驱动学习',
                        '面试指导',
                        '工作内推'
                    ]
                },
                {
                    id: 3,
                    name: '前端全栈开发培训',
                    category: 'training',
                    description: '系统学习HTML5、CSS3、JavaScript、Vue/React等前端技术，掌握Node.js后端开发，培养全栈开发能力。课程包含多个企业级项目实战。',
                    shortDesc: '从前端到全栈，一站式掌握现代Web开发技术',
                    price: 7500,
                    duration: '3.5个月',
                    image: require('@/assets/images/base.png'),
                    tags: ['Vue', 'React', 'Node.js'],
                    techStack: [
                        {name: 'Vue', logo: require('@/assets/images/base.png')},
                        {name: 'React', logo: require('@/assets/images/base.png')},
                        {name: 'Node.js', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '资深前端讲师',
                        '项目代码评审',
                        'Git团队协作',
                        '职业规划指导'
                    ],
                    architecture: require('@/assets/images/base.png')
                },

                // 软件开发
                {
                    id: 4,
                    name: '企业ERP系统开发',
                    category: 'development',
                    description: '基于Java技术栈开发的企业资源计划系统，包含采购、销售、库存、财务、人力资源等模块，支持多终端访问，可根据企业需求定制功能。',
                    shortDesc: '定制化企业资源管理系统，提升运营效率',
                    price: '面议',
                    duration: '3-6个月',
                    image: require('@/assets/images/base.png'),
                    tags: ['Java', 'Spring Cloud', 'Vue'],
                    techStack: [
                        {name: 'Spring Cloud', logo: require('@/assets/images/base.png')},
                        {name: 'Vue', logo: require('@/assets/images/base.png')},
                        {name: 'Redis', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '模块化设计',
                        '高并发处理',
                        '数据安全保障',
                        '后期维护支持'
                    ],
                    architecture: require('@/assets/images/base.png')
                },
                {
                    id: 5,
                    name: '电商平台开发',
                    category: 'development',
                    description: '全功能电商平台开发，包含商品管理、订单处理、支付对接、会员系统、营销工具等模块，支持PC端和移动端。',
                    shortDesc: '一站式电商解决方案，快速搭建在线商城',
                    price: '面议',
                    duration: '2-5个月',
                    image: require('@/assets/images/base.png'),
                    tags: ['PHP', 'Laravel', '小程序'],
                    techStack: [
                        {name: 'Laravel', logo: require('@/assets/images/base.png')},
                        {name: '小程序', logo: require('@/assets/images/base.png')},
                        {name: '支付系统', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '多种支付方式集成',
                        '高性能架构设计',
                        'SEO优化',
                        '数据分析支持'
                    ]
                },
                {
                    id: 6,
                    name: '移动应用开发',
                    category: 'development',
                    description: '专业的iOS和Android应用开发服务，包含UI设计、功能开发、API对接、测试上线等全流程服务。',
                    shortDesc: '专业团队打造高性能移动应用',
                    price: '面议',
                    duration: '1-4个月',
                    image: require('@/assets/images/base.png'),
                    tags: ['Flutter', 'React Native', 'API'],
                    techStack: [
                        {name: 'Flutter', logo: require('@/assets/images/base.png')},
                        {name: 'React Native', logo: require('@/assets/images/base.png')},
                        {name: 'RESTful API', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '跨平台解决方案',
                        '原生性能体验',
                        '严格测试流程',
                        '应用商店上架支持'
                    ],
                    architecture: require('@/assets/images/base.png')
                },

                // 解决方案
                {
                    id: 7,
                    name: '智慧校园解决方案',
                    category: 'solution',
                    description: '整合教务管理、在线学习、校园生活服务等功能的智慧校园平台，助力教育机构数字化转型。',
                    shortDesc: '一站式校园数字化解决方案',
                    price: '面议',
                    duration: '定制化',
                    image: require('@/assets/images/base.png'),
                    tags: ['SaaS', '云计算', '大数据'],
                    techStack: [
                        {name: '云计算', logo: require('@/assets/images/base.png')},
                        {name: '大数据', logo: require('@/assets/images/base.png')},
                        {name: 'SaaS', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '模块化设计',
                        '多终端支持',
                        '数据可视化',
                        '系统集成能力'
                    ]
                },
                {
                    id: 8,
                    name: '医疗健康管理系统',
                    category: 'solution',
                    description: '为医疗机构定制的健康管理系统，包含预约挂号、电子病历、药品管理、数据分析等功能模块。',
                    shortDesc: '专业医疗健康管理解决方案',
                    price: '面议',
                    duration: '定制化',
                    image: require('@/assets/images/base.png'),
                    tags: ['Java', '微服务', '安全'],
                    techStack: [
                        {name: 'Java', logo: require('@/assets/images/base.png')},
                        {name: '微服务', logo: require('@/assets/images/base.png')},
                        {name: '安全认证', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '医疗数据安全保障',
                        '高可用架构',
                        '合规性设计',
                        '系统扩展性强'
                    ],
                    architecture: require('@/assets/images/base.png')
                },

                // 技术咨询
                {
                    id: 9,
                    name: '系统架构咨询',
                    category: 'consulting',
                    description: '资深架构师团队提供系统架构设计咨询，包括技术选型、架构设计、性能优化等专业建议。',
                    shortDesc: '专业架构设计咨询服务',
                    price: '2000/天',
                    duration: '按需',
                    image: require('@/assets/images/base.png'),
                    tags: ['架构', '优化', '设计'],
                    techStack: [
                        {name: '架构设计', logo: require('@/assets/images/base.png')},
                        {name: '性能优化', logo: require('@/assets/images/base.png')},
                        {name: '云原生', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '10年以上经验专家',
                        '定制化方案',
                        '技术风险评估',
                        '长期支持'
                    ]
                },
                {
                    id: 10,
                    name: 'DevOps咨询',
                    category: 'consulting',
                    description: '帮助企业建立DevOps流程，实现持续集成、持续交付，提升软件交付效率和质量。',
                    shortDesc: '提升软件交付效率的DevOps实践咨询',
                    price: '1800/天',
                    duration: '按需',
                    image: require('@/assets/images/base.png'),
                    tags: ['CI/CD', '自动化', '监控'],
                    techStack: [
                        {name: 'Docker', logo: require('@/assets/images/base.png')},
                        {name: 'K8s', logo: require('@/assets/images/base.png')},
                        {name: 'CI/CD', logo: require('@/assets/images/base.png')}
                    ],
                    benefits: [
                        '流程优化',
                        '工具链建设',
                        '自动化实践',
                        '团队培训'
                    ]
                }
            ],
            activeCells: []
        }
    },
    computed: {
        filteredServices() {
            return this.services.filter(service => service.category === this.activeCategory)
        }
    },
    methods: {
        handleTabChange(tab) {
            this.activeCategory = tab.name
        },
        handleConsult(service) {
            this.detailVisible = false
            this.$router.push({
                path: '/contact',
                query: {
                    service: service.name
                }
            })
        },
        showServiceDetail(service) {
            this.currentService = {
                ...service
            }
            this.detailVisible = true
        },
        activateCell(index) {
            if (!this.activeCells.includes(index)) {
                this.activeCells.push(index)
                setTimeout(() => {
                    this.activeCells = this.activeCells.filter(i => i !== index)
                }, 1000)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.wenhui-services-page {
    padding-top: 80px;
    background-color: #f5f7fa;

    .tech-services-banner {
        height: 500px;
        background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #fff;
        position: relative;
        overflow: hidden;

        .banner-content {
            position: relative;
            z-index: 2;
            
            h1 {
                font-size: 60px;
                margin: 0 0 15px;
                font-weight: 700;
                text-shadow: 0 2px 10px rgba(0,0,0,0.3);
            }

            p {
                font-size: 24px;
                margin: 0;
                opacity: 0.9;
            }
        }

        .tech-grid {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            grid-template-rows: repeat(6, 1fr);
            z-index: 1;

            .grid-cell {
                border: 1px solid rgba(255,255,255,0.05);
                transition: all 0.3s ease;
                
                &:hover {
                    background: rgba(64, 158, 255, 0.3);
                }
            }
        }
    }

    .section {
        padding: 80px 0;

        &.tech-categories {
            background-color: #fff;
        }

        &.tech-service-list {
            background-color: #f5f7fa;
        }
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .tech-tabs {
        /deep/ .el-tabs__nav-wrap::after {
            background-color: #eee;
        }

        /deep/ .el-tabs__item {
            font-size: 18px;
            padding: 0 25px;
            height: 60px;
            line-height: 60px;
            font-weight: 500;

            &.is-active {
                color: #409EFF;
            }
        }

        /deep/ .el-tabs__active-bar {
            background-color: #409EFF;
            height: 3px;
        }
    }

    .tech-category-description {
        text-align: center;
        color: #666;
        padding: 20px 0 40px;
        font-size: 16px;
        max-width: 800px;
        margin: 0 auto;
        line-height: 1.8;
    }

    .tech-service-card {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        transition: all 0.3s;
        margin-bottom: 30px;
        cursor: pointer;

        &:hover {
            transform: translateY(-10px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
        }

        .tech-service-image {
            position: relative;
            height: 200px;
            overflow: hidden;
            
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.5s;
            }

            .tech-service-tags {
                position: absolute;
                bottom: 15px;
                left: 0;
                right: 0;
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                
                span {
                    background: rgba(64, 158, 255, 0.9);
                    color: #fff;
                    padding: 3px 10px;
                    border-radius: 15px;
                    font-size: 12px;
                    margin: 0 5px 5px;
                }
            }

            &:hover img {
                transform: scale(1.1);
            }
        }

        .tech-service-content {
            padding: 20px;
            
            h3 {
                font-size: 18px;
                margin: 0 0 10px;
                color: #333;
                font-weight: 600;
            }

            .tech-service-meta {
                display: flex;
                justify-content: space-between;
                margin-bottom: 15px;
                font-size: 14px;
                color: #666;

                .duration {
                    i {
                        margin-right: 5px;
                    }
                }

                .price {
                    color: #F56C6C;
                    font-weight: bold;
                }
            }

            .tech-service-desc {
                color: #666;
                font-size: 14px;
                line-height: 1.6;
                margin-bottom: 15px;
                min-height: 60px;
            }

            .tech-service-footer {
                text-align: center;
            }
        }
    }

    .tech-service-dialog {
        /deep/ .el-dialog {
            border-radius: 12px;
            overflow: hidden;
            max-width: 1200px;

            &__header {
                background-color: #f5f7fa;
                padding: 20px;
                border-bottom: 1px solid #eee;
            }

            &__body {
                padding: 30px;
            }

            &__footer {
                padding: 20px;
                text-align: center;
                border-top: 1px solid #eee;
            }
        }

        .tech-service-detail {
            .tech-detail-image {
                img {
                    width: 100%;
                    border-radius: 8px;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
                    margin-bottom: 20px;
                }

                .tech-stack {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 15px;

                    .tech-stack-item {
                        display: flex;
                        align-items: center;
                        background: #f5f7fa;
                        padding: 8px 12px;
                        border-radius: 20px;
                        font-size: 12px;

                        img {
                            width: 20px;
                            height: 20px;
                            margin-right: 8px;
                        }
                    }
                }
            }

            .tech-detail-content {
                .tech-detail-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;

                    h3 {
                        font-size: 24px;
                        margin: 0;
                        color: #333;
                    }

                    .tech-price {
                        .amount {
                            font-size: 24px;
                            font-weight: bold;
                            color: #F56C6C;
                        }

                        .duration {
                            font-size: 14px;
                            color: #999;
                        }
                    }
                }

                .tech-divider {
                    margin: 20px 0;
                    background-color: #ebeef5;
                }

                .tech-detail-section {
                    margin-bottom: 25px;

                    h4 {
                        font-size: 18px;
                        color: #333;
                        margin: 0 0 15px;
                        display: flex;
                        align-items: center;

                        i {
                            margin-right: 8px;
                            color: #409EFF;
                        }
                    }

                    p {
                        color: #666;
                        line-height: 1.8;
                        margin: 0;
                    }

                    .tech-benefits {
                        list-style: none;
                        padding: 0;
                        margin: 0;

                        li {
                            margin-bottom: 10px;
                            color: #666;
                            display: flex;
                            align-items: flex-start;
                            line-height: 1.6;

                            i {
                                color: #67C23A;
                                margin-right: 8px;
                                font-size: 16px;
                            }
                        }
                    }

                    .tech-architecture {
                        img {
                            max-width: 100%;
                            border: 1px solid #eee;
                            border-radius: 5px;
                        }

                        p {
                            color: #666;
                            line-height: 1.8;
                        }
                    }
                }
            }
        }

        .tech-dialog-footer {
            display: flex;
            justify-content: center;
            gap: 30px;

            .tech-cancel-btn {
                width: 120px;
                height: 42px;
                border-radius: 21px;
                border: 1px solid #dcdfe6;
                background: #fff;
                color: #606266;
                font-size: 16px;
                transition: all 0.3s;

                &:hover {
                    color: #409EFF;
                    border-color: #409EFF;
                    background: #fff;
                }
            }

            .tech-consult-btn {
                width: 120px;
                height: 42px;
                border-radius: 21px;
                background: #409EFF;
                border: none;
                color: #fff;
                font-size: 16px;
                transition: all 0.3s;

                &:hover {
                    background: #66b1ff;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
                }

                &:active {
                    transform: translateY(0);
                }
            }
        }
    }

    @media (max-width: 992px) {
        .tech-service-detail {
            .el-col {
                &:first-child {
                    margin-bottom: 30px;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .tech-services-banner {
            height: 350px;
            
            h1 {
                font-size: 36px;
            }

            p {
                font-size: 18px;
            }
        }

        .tech-tabs {
            /deep/ .el-tabs__item {
                font-size: 16px;
                padding: 0 15px;
            }
        }

        .tech-service-dialog {
            /deep/ .el-dialog {
                width: 90% !important;

                &__body {
                    padding: 20px;
                }
            }

            .tech-dialog-footer {
                flex-direction: column;
                gap: 15px;

                .tech-cancel-btn,
                .tech-consult-btn {
                    width: 100%;
                }
            }
        }
    }

    @media (max-width: 576px) {
        .tech-services-banner {
            height: 300px;
            
            h1 {
                font-size: 28px;
            }

            p {
                font-size: 16px;
            }
        }

        .tech-tabs {
            /deep/ .el-tabs__item {
                font-size: 14px;
                padding: 0 10px;
            }
        }
    }
}

@keyframes gridActive {
    0% { background: rgba(64, 158, 255, 0); }
    50% { background: rgba(64, 158, 255, 0.3); }
    100% { background: rgba(64, 158, 255, 0); }
}
</style>